import { getReducerErrorMessage } from 'src/utils/helpers'

const initialState = {
  selectedPaymentPolicies: [],
  paymentPoliciesTimestamp: 0,
  paymentPolicies: [],
  loadingPaymentOptions: false,
  getPolicyDetailsResponse: {},
  submitPayment: false,
  paymentSuccessful: false,
  document: 'barev',
  driver: 'ooo',
}

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case 'RESET_PAYMENTS_STATE': {
      return initialState
    }

    /**
     *
     * TODO: PAT-1574 Remove this when "Stripe" is removed
     *
     * @deprecated
     */
    case 'GET_POLICIES': {
      return {
        ...state,
        loadingPolicies: true,
      }
    }
    case 'GET_POLICIES_COMMIT': {
      return {
        ...state,
        loadingPolicies: false,
        policies: action.payload,
      }
    }
    case 'GET_POLICIES_ROLLBACK': {
      return {
        ...state,
        loadingPolicies: false,
      }
    }

    case 'SET_SELECTED_PAYMENT_POLICIES': {
      return {
        ...state,
        selectedPaymentPolicies: action.payload.selectedPaymentPolicies,
      }
    }

    case 'GET_PAYMENT_OPTIONS': {
      return {
        ...state,
        paymentPoliciesTimestamp: 0,
        loadingPaymentOptions: true,
        getPolicyDetailsResponse: {},
      }
    }
    case 'changeRequest/GET_POLICY_DETAILS_COMMIT': {
      return {
        ...state,
        paymentPoliciesTimestamp: new Date().getTime(),
        paymentPolicies: action.payload,
        loadingPaymentOptions: false,
        getPolicyDetailsResponse: {
          success: true,
        },
      }
    }
    case 'changeRequest/GET_POLICY_DETAILS_ROLLBACK': {
      return {
        ...state,
        paymentPoliciesTimestamp: 0,
        loadingPaymentOptions: false,
        getPolicyDetailsResponse: {
          success: false,
          message: getReducerErrorMessage(action),
        },
      }
    }

    case 'SET_DOCUMENT': {
      console.log(action.payload, 'document')
      return {
        ...state,
        document: action.payload.document,
      }
    }

    default: {
      return state
    }
  }
}
